export default __webpack_public_path__ + "static/media/Duplicate.dc1b358e.svg";